// productFilterSlice.js
import {createSlice} from '@reduxjs/toolkit';

const productFilterSlice = createSlice({
  name: 'productFilterSlice',
  initialState: {
    productId: null,
    productCategories: '',
    productCasbinKey: '',
  },
  reducers: {
    setProductIdValue: (state, action) => {
      state.productId = action.payload;
    },
    clearProductIdValue: state => {
      state.productId = null;
    },
    setProductCategoriesValue: (state, action) => {
      state.productCategories = action.payload;
    },
    clearProductCategoriesValue: state => {
      state.productCategories = '';
    },
    setProductCasbinKey: (state, action) => {
      state.productCasbinKey = action.payload;
    },
    clearProductCasbinKey: state => {
      state.productCasbinKey = '';
    },
  },
});

export const {
  setProductIdValue,
  clearProductIdValue,
  setProductCategoriesValue,
  clearProductCategoriesValue,
  setProductCasbinKey,
  clearProductCasbinKey,
} = productFilterSlice.actions;
export default productFilterSlice.reducer;
